export default __webpack_public_path__ + "static/media/browser1.a919783b.png";